// 004 (research R4; data-model §8): messages between the app and the Leaflet page in the Android
// WebView. Anything malformed or unknown is dropped. Messages are never logged (FR-039).
import type { LatLng } from "./types";

export type BridgeIn =
  | { t: "ready" }
  | { t: "moved"; lat: number; lng: number; byUser: boolean }
  | { t: "tileError" }
  | { t: "attribution" };

export const round6 = (n: number) => Math.round(n * 1e6) / 1e6;

const finiteIn = (v: unknown, limit: number): v is number =>
  typeof v === "number" && Number.isFinite(v) && Math.abs(v) <= limit;

export function parseBridgeMessage(raw: string): BridgeIn | null {
  let v: unknown;
  try {
    v = JSON.parse(raw);
  } catch {
    return null;
  }
  if (typeof v !== "object" || v === null) return null;
  const m = v as Record<string, unknown>;
  switch (m.t) {
    case "ready":
      return { t: "ready" };
    case "tileError":
      return { t: "tileError" };
    case "attribution":
      return { t: "attribution" };
    case "moved":
      if (
        !finiteIn(m.lat, 90) ||
        !finiteIn(m.lng, 180) ||
        typeof m.byUser !== "boolean"
      )
        return null;
      return {
        t: "moved",
        lat: round6(m.lat),
        lng: round6(m.lng),
        byUser: m.byUser,
      };
    default:
      return null;
  }
}

export function setViewMessage(center: LatLng, zoom: number): string {
  return JSON.stringify({
    t: "setView",
    lat: round6(center.latitude),
    lng: round6(center.longitude),
    zoom,
  });
}
